export function clinicDetailsArray(clinic, t, infoElevation) {
    return [
      {
        title: t("Country"),
        value: t(clinic?.country),
        testId: "about-us.contact.country",
      },
      {
        title: t("City"),
        value: clinic?.city,
        testId: "about-us.contact.city",
      },
      {
        title: t("ZipCode"),
        value: clinic?.zipCode,
        testId: "about-us.contact.zip-code",
      },
      {
        title: t("StreetAddress"),
        value: clinic?.streetAddress,
        testId: "about-us.contact.street-address",
      },
      {
        title: t("Email"),
        value: clinic?.email,
        testId: "about-us.contact.email",
      },
      {
        title: t("PhoneNumber"),
        value: clinic?.phoneNumber,
        testId: "about-us.contact.phone-number",
      },
      {
        title: t("LinkToClinicPage"),
        value: clinic?.url,
        testId: "about-us.contact.url",
      },
    ];
  }
  